module.exports = __webpack_public_path__ + "img/butuiding.3bcbb69b.svg";